export default __webpack_public_path__ + "static/media/info.47e70fd5.svg";